import { Dayjs } from 'dayjs'
import { Judgement, PaginationModel } from './base-model'
import { Color } from 'antd/es/color-picker'

interface MeetingQueryModel extends PaginationModel {
  user_id?: string
  meeting_progress?: number
  org_name?: string
  meeting_name?: string
  org_id?:string
  order_by_column?:string
  order_by_sort?:string
}

interface MeetingModel {
  id?: string
  meeting_id?: string
  create_time?: string
  meeting_url?: string
  fullname?: string
  username?: string
  org_name_en?: string
  org_name_zh?: string
  meeting_name_en?: string
  meeting_name_zh?: string
  start_time?: string
  end_time?: string
  system_open_time?: string
  system_close_time?: string
  time_zone?: string
  time_zone_label?: string
  attendee_count?: number
  user_id?: string
  org_id?: string
  config_step?: number
  attend_approval_required?: Judgement
  delete_requested_by?: string
  meeting_progress?: MeetingProgress
  delete_status?:number
  user_phone?: string,
  user_email?: string,
  generate_image_quota?:number
}

interface MeetingFormModel extends Omit<MeetingModel, 'user_id'> {
  meeting_time: Dayjs[]
  opening_hours: Dayjs[]
  user_id: string[]
}

interface MeetingThemeModel {
  invitations?: Invitation[]
  meeting_type?: string
  scenario_id?: string
  is_registration_approved?: number
  scene_id?: string
  cloth_id?: string
  seating_capacity?: number | string
  login_img?: string
  brand_img?: string
  venue_img?: string
  screen_img?: string
  warmup_video?: string
  icon_palette?: string
  scenario_type?: string
  cloth_series_id?: string
  figure_background_id?: string
  sign_img?:string
}

interface MeetingConfigFormModel extends MeetingFormModel, MeetingThemeModel {}

interface Invitation {
  is_speaker?: string
  is_meeting_admin?: string
  is_recorder?: string
  has_custom_profile?: string
  custom_url?: string
  npc_id?: string
  invitations_id?: string
}

interface AddMeetingConfigModel extends MeetingThemeModel {
  meeting_time?: Dayjs[]
  icon_palette_color: Color
}

interface InvitationParamsModel {
  ivitation_dto?: InvitationModel
  invitation_list?: ContactModel[]
}

interface ContactModel {
  contact_info?: string
  fullname?: string
  company?: string
  invitation_method?: SendTypeValue
}

interface InvitationModel {
  subject?: string
  recipient?: string
  cc?: string
  bcc?: string
  content?: string
  invitation_method?: SendTypeValue
  meeting_id?: string
  meeting_url?: string
  start_time?: string
  time_zone?: string
  time_zone_label?: string
}

interface DraftParamsModel {
  meeting_id: string
  email_draft?: string
  sms_draft?: string
}

export enum SendTypeValue {
  Email = '1',
  Sms = '0'
}

interface DraftQueryModel {
  meeting_id?: string
}

interface DraftModel {
  id?: string
  email_draft?: string
  sms_draft?: string
  meeting_id?: string
}

interface MeetingStepParams {
  meeting_id: string
  config_step: number | string
}

interface MeetingThemeInfoModel extends MeetingThemeModel {
  id?: string
  meeting_id?: string
  create_time?: string
  update_time?: string
}

interface MeetingGoodModel {
  id: string
  goods_id: string
  meeting_id: string
}

export enum MeetingProgress {
  NOT_STARTED, //会议未开始
  IN_PROGRESS, //会议进行中
  END, //已结束
  DELETED //已删除
}

interface MeetingInvitationQueryModel extends PaginationModel {
  meeting_id?: string
  sender_id?: string
}

interface MeetingInvitationModel {
  id?: string
  contact_info?: string
  fullname?: string
  company?: string
  invitation_method?: number
  invitation_time?: string
}

export type {
  MeetingModel,
  MeetingFormModel,
  MeetingThemeModel,
  Invitation,
  AddMeetingConfigModel,
  MeetingConfigFormModel,
  InvitationModel,
  InvitationParamsModel,
  ContactModel,
  DraftParamsModel,
  DraftQueryModel,
  DraftModel,
  MeetingQueryModel,
  MeetingStepParams,
  MeetingThemeInfoModel,
  MeetingGoodModel,
  MeetingInvitationQueryModel,
  MeetingInvitationModel
}
